import {
  CheckoutComponentChatAttibutesType,
  CheckoutComponentChatProvider,
} from "../../types/builder";
import Crisp from "../chats/Crisp";
import Facebook from "../chats/Facebook";
import FreshChat from "../chats/FreshChat";
import Intercom from "../chats/Intercom";
import JivoChat from "../chats/JivoChat";
import ManyChat from "../chats/ManyChat";
import Tawk from "../chats/Tawk";
import Whatsapp from "../chats/Whatsapp";
import Zendesk from "../chats/Zendesk";

const Chat = {
  [CheckoutComponentChatProvider.WHATSAPP]: Whatsapp,
  [CheckoutComponentChatProvider.JIVOCHAT]: JivoChat,
  [CheckoutComponentChatProvider.ZENDESK]: Zendesk,
  [CheckoutComponentChatProvider.MANYCHAT]: ManyChat,
  [CheckoutComponentChatProvider.CRISP]: Crisp,
  [CheckoutComponentChatProvider.TAWK]: Tawk,
  [CheckoutComponentChatProvider.FACEBOOK]: Facebook,
  [CheckoutComponentChatProvider.FRESHCHAT]: FreshChat,
  [CheckoutComponentChatProvider.INTERCOM]: Intercom,
};

const CheckoutComponentChat: React.FC<CheckoutComponentChatAttibutesType> = ({
  accountId,
  provider,
}) => {
  if (!(provider in Chat)) {
    return null;
  }

  const Component = Chat[provider] as React.FC<
    Pick<CheckoutComponentChatAttibutesType, "accountId">
  >;

  return Component && <Component accountId={accountId} />;
};

export default CheckoutComponentChat;
